export const routes = (prefix) => [
    {
        path: `/${prefix}/assets`,
        name: `${prefix}.assets.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.assets.index`,
                PageDescription: "Assets Listing/Create",
            }
        }
    },
];
